import { Heading2XL, Heading3XL } from "../typography";
import {
  getFeatureSections,
  testimonials,
} from "./payor_case_management/config/payorCaseManagementConfig";

import { CardSection } from "./payor_case_management/components/CardSection";
import { CarouselSection } from "./payor_case_management/components/CarouselSection";
import { FeatureSection } from "./components/sections/FeatureSection";
import { Footer } from "./footer/NewFooter";
import { Fragment } from "react";
import { GridCard } from "./components/ui/GridCard";
import { Hero } from "./payor_case_management/components/Hero";
import ProviderNavigation from "../ProviderNavigation";
import { useMediaQuery } from "../hooks/useMediaQuery";

export default function PayorCaseManagementPage() {
  const isDesktop = useMediaQuery("(min-width: 440px)");
  const featureSections = getFeatureSections(isDesktop);

  const GridCards = testimonials.map((testimonial, idx) => (
    <GridCard
      key={`testimonial-${idx}`}
      testimonial={testimonial}
      className={
        "tw-z-20 tw-h-[305px] tw-w-[353px] min440:tw-h-[20em] min440:tw-w-[28.5em]"
      }
    />
  ));

  return (
    <div className="tw-relative tw-min-h-screen tw-overflow-x-hidden">
      <div className="tw-bg-[#010869] tw-bg-[url('/landing_page_assets/backgrounds/bg2.jpg')] tw-bg-cover">
        <ProviderNavigation isDark />
        <div className="tw-relative tw-mx-auto tw-mt-[48px] tw-max-w-[1448px] tw-px-[20px] tw-pb-[64px]">
          <Hero />
        </div>
      </div>

      <div className="tw-mt-[5em] tw-flex tw-flex-col tw-items-center tw-gap-y-[4em] min440:tw-mt-[7.5em]">
        <Heading3XL className="tw-my-0 tw-hidden tw-text-center tw-text-blue-dark-3 min440:tw-flex">
          What our case management customers say
        </Heading3XL>
        <Heading2XL className="tw-my-0 tw-text-center tw-text-blue-dark-3 min440:tw-hidden">
          What our case management customers say
        </Heading2XL>
        <CarouselSection items={GridCards.concat(GridCards)} />
      </div>
      <div className="tw-relative tw-mx-auto tw-flex tw-h-full tw-max-w-[1448px] tw-flex-col tw-gap-y-[80px] tw-overflow-hidden tw-px-[20px] tw-py-[56px] min440:tw-gap-y-[120px] min440:tw-px-[76px]">
        <img
          src="/landing_page_assets/payor_network_page/lightsquiggle.svg"
          className="tw-absolute tw-right-[10em] tw-top-[60em] tw-z-0 tw-aspect-[2/1]"
        />
        {featureSections.map((section, index) => (
          <Fragment key={`feature-section-${index}`}>
            <FeatureSection {...section} imageClassName="tw-aspect-[574/431]" />
            {index === 1 && <CardSection />}
          </Fragment>
        ))}
        <img
          src="/landing_page_assets/payor_network_page/lightsquiggle.svg"
          className="tw-absolute tw-bottom-[-100px] tw-left-[100px] tw-z-0 tw-aspect-[2/1]"
        />
      </div>
      <Footer
        title="Partner with"
        titleAccent="Verse"
        description="Learn more about how Verse works with case management teams."
        buttonText="Book a demo"
        isRounded
        hasSquiggle
      />
    </div>
  );
}
